// extracted by mini-css-extract-plugin
module.exports = {"searchWrap":"Home-module--searchWrap--1PW12","section":"Home-module--section--n5vtc","loaderWrap":"Home-module--loaderWrap--IRb_L"};